function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

function getURL( url ) {
    const env = getEnvironment();
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const currentEnv = getEnvironment();
export const deckUrl = getURL( 'https://(env.)recognition-now.io/component-deck' );
export const versionUrl = getURL( 'https://(env.)recognition-now.io/umbrella-path-versions/component-deck.json' );
export const eventProxyUrl = getURL( 'https://(env.)api.biw.cloud/v1/web-event-proxy' );
export const cypherUrl = getURL( 'https://(env.)api.biw.cloud/v1/cypher' );
